import lang from '@/lang'
export const exportToCSV = (assetData, depreciationMethodLabel, description, number) => {
  const header = [
    lang.economicAsset.excelExport.headerYear,
    depreciationMethodLabel,
    lang.economicAsset.excelExport.headerCommunicates,
    lang.economicAsset.excelExport.headerBookValue,
  ].join(';')

  const rows = assetData?.flat()
  const csvContent = rows.map((data) => [
    data.year,
    data.depreciationAmount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    data.accumulatedDepreciationAmount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
    data.endingBookValue.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  ].join(';'))

  const csv = [header, ...csvContent].join('\n')
  const blob = new Blob([csv], { type: 'text/csv' })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = `Abschreibungsverlauf_zu_${description}_${number}.csv`
  link.click()
}
